import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import * as State from '@shared/state';

import { ListsComponent } from '../../lists.shared.component';

@Component({
    selector: 'shared-list-for-reorder-items',
    templateUrl: './list-for-reorder-items.shared.component.html',
    styleUrls: ['./list-for-reorder-items.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForReorderItemsComponent extends ListsComponent {
    @Input() public maxOnScreenHeight: string = null;
    @Input() public bottomPadding: boolean = true;
    @Input() public reorderItems: Array<State.ICartMenuFlowExtended | State.ICartSimpleItemExtended>;

    @Output() public onSelected: EventEmitter<{ event: Event, item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }> = new EventEmitter();
    @Output() public onDeselected: EventEmitter<{ event: Event, item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }> = new EventEmitter();

    constructor() {
        super();
    }

    public trackBy(index: number, orderItem: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended): number {
        return orderItem?._Id || index;
    }

    public handleSelected(data: { event: Event, item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }): void {
        this.onSelected.emit(data);
    }

    public handleDeselected(data: { event: Event, item: State.ICartMenuFlowExtended | State.ICartSimpleItemExtended; }): void {
        this.onDeselected.emit(data);
    }
}
